/**
 * @import { PortInfo } from '@/features/itinerary-map/types/port-info'
 */

import { createContext, useContext } from 'react';

/**
 * @typedef {object} PortInfoContext
 * @property {PortInfo | null} portInfo
 * @property {React.Dispatch<React.SetStateAction<PortInfo | null>>} setPortInfo
 */

/** @type {React.Context<PortInfoContext>} */
// @ts-ignores
export const PortInfoContext = createContext(null);

export const usePortInfoContext = () => useContext(PortInfoContext);
